var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thanks"},[_vm._v("感谢！")])
}
var staticRenderFns = []

export { render, staticRenderFns }